/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// Hinweis: Transiente "Unexpected end of JSON input"-Fehler nach dem Aufwachen
// aus dem Standby (abgebrochene PouchDB-/Keycloak-fetch-Requests) werden zentral
// im ConsoleErrorService (luzula-lib) im Aufwach-Zeitfenster unterdrückt –
// sowohl auf dem console.error- als auch auf dem unhandledrejection-Weg.

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
